var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5938 30.9609V23.9297C13.5938 21.7718 15.3422 20.0234 17.5 20.0234V20.0234C19.6578 20.0234 21.4062 21.7718 21.4062 23.9297V30.9609H30V17.5453C30 16.7172 29.6703 15.9218 29.0844 15.3359L18.6047 4.85621C17.9937 4.24528 17.0047 4.24528 16.3953 4.85621L5.91563 15.3359C5.32969 15.9218 5 16.7172 5 17.5453V30.9609H13.5938Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.aa6e0ad4fcf44fbbf62b113593003d50.svg";
export { ForwardRef as ReactComponent };